import { Button } from '@antimatterhq/ui/components/button';

export interface RunQueryProps {
  running: boolean;
  onClick?: () => void;
  status?: string;
  disabled?: boolean;
}

export const RunQuery = ({
  running,
  onClick: onToggle,
  status,
  disabled,
}: RunQueryProps) => {
  return (
    <div className="flex min-w-[200px] items-center justify-end gap-2">
      <span className="text-sm text-gray-600">{status}</span>
      <Button
        onClick={onToggle}
        variant="primary"
        loading={running}
        disabled={disabled}
      >
        {running ? 'Cancel' : 'Run query'}
      </Button>
    </div>
  );
};
